import { useState, type FormEvent } from "react";
import {
  AcpAvatarChat,
  type AcpAvatarChatConfig,
} from "@pineseed/interface-gui/component/AcpAvatarChat";

export interface WorkspaceKeyAcpAvatarChatProps {
  config: AcpAvatarChatConfig;
  isAuthenticated: boolean;
}

export function WorkspaceKeyAcpAvatarChat({ config, isAuthenticated }: WorkspaceKeyAcpAvatarChatProps) {
  // Draft is edited freely; only the applied key drives the ACP connection.
  const [draftKey, setDraftKey] = useState("");
  const [appliedKey, setAppliedKey] = useState("");

  const trimmedDraft = draftKey.trim();

  const onConnect = (e: FormEvent) => {
    e.preventDefault();
    setAppliedKey(trimmedDraft);
  };

  return (
    <div className="flex flex-col gap-4">
      <form onSubmit={onConnect}>
        <label htmlFor="acp-workspace-key" className="text-xs text-gray-500 dark:text-gray-400">Workspace Key</label>
        <div className="flex gap-2 mt-1">
          <input
            id="acp-workspace-key"
            type="text"
            value={draftKey}
            onChange={(e) => setDraftKey(e.target.value)}
            className="w-full px-2 py-1 text-sm border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
            placeholder="workspace key"
          />
          <button
            type="submit"
            disabled={!trimmedDraft || trimmedDraft === appliedKey}
            className="px-3 py-1 text-sm border rounded disabled:opacity-50 disabled:cursor-not-allowed dark:border-gray-600 dark:text-gray-100"
          >
            Connect
          </button>
        </div>
      </form>
      {appliedKey ? (
        <AcpAvatarChat key={appliedKey} config={config} workspaceKey={appliedKey} isAuthenticated={isAuthenticated} />
      ) : (
        <p>Enter a workspace key to connect</p>
      )}
    </div>
  );
}
